import { Component, OnInit, ViewEncapsulation, Inject, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CmsPageService } from 'src/app/services/cms-page.service';
import { Constant } from 'src/app/constant/constant';
import { HomePageService } from 'src/app/services/home-page.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'calsoft-copy-template',
  templateUrl: './copy-template.component.html',
  styleUrls: ['./copy-template.component.scss']
})
export class CopyTemplateComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  data: any;

  firstFormGroup: UntypedFormGroup;
  text: string;
  currentUuid: any;
  uuid: any;
  title: any;
  pageId: any;
  constructor(
    private dialogRef: MatDialogRef<CopyTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public formBuilder: UntypedFormBuilder,
    private cmsPageService: CmsPageService,
    private homePageService:HomePageService,
    private snackBar:MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,

  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

    this.data = data;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  
    

  }

  ngOnInit() {
    this.text = 'Save';
    this.firstFormGroup = this.formBuilder.group({
      uuid: ['', [Validators.required]],
    });


    this.getCmsData();

    this.currentUuid=this.data.value;

    this.title = this.data.title;
    
  }

  
  getCmsData() {
    this.getCmsList();
    this.CmsYFilter();
    this.getAllCmsSet();
  }

  

  close() {
    this.dialogRef.close({ event: 'close'})
  }





  
  //cms
  public cmsFilterControl: UntypedFormControl = new UntypedFormControl();

  cmsList: any;
  cmsTypeList: any;
  filteredCmsTypeList: any;

  getCmsList() {

    this.cmsPageService.getAllCmsDropDown().subscribe(
      res => {
      
        this.cmsList = res;

        if(this.router.url.includes("/home-page-construction")){

        }else{

        let index = this.cmsList.findIndex(x => x.title == this.data.title)
        this.cmsList.splice(index, 1);

        }

        this.cmsTypeList = res;
        this.filteredCmsTypeList = this.cmsTypeList;
      },
      error => {
      })

    }

    protected _onDestroy = new Subject<void>();

  CmsYFilter() {
    this.cmsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.CmsFilter();
      });
  }


  protected CmsFilter() {
    if (!this.cmsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.cmsFilterControl.value;
    if (!search) {
      this.filteredCmsTypeList = this.cmsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredCmsTypeList = this.cmsTypeList.filter(cms => cms['title']
      .toLowerCase().indexOf(search) > -1)
  }

  getAllCmsSet() {
    this.filteredCmsTypeList = this.cmsTypeList;
  }

  duplicate() {
    this.uuid = this.firstFormGroup.value.uuid;

    this.router.navigate([`page/duplicatePage/${this.title}/${this.currentUuid}/${this.uuid}`]);

    this.dialogRef.close({ event: 'close'})
  }

  copyData(){

    if(this.firstFormGroup.valid){
      let object={
        uuid:this.firstFormGroup.value.uuid,
        currentUuid:this.data.value,
        currentPageType:this.data.type
  
      }

      this.homePageService.copyLayout(object).subscribe(
        (response) => {
       
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', {
                panelClass: 'success',
                verticalPosition: 'bottom',
                duration: 500,
              });
              this.text = 'Save';

              this.dialogRef.close({ event: 'add'})

            } else {
              this.snackBar.open(response['status_message'], '×', {
                panelClass: 'error',
                verticalPosition: 'bottom',
                duration: 500,
              });
            }
          
        },
        (err) => {
          this.text = 'Save';
        }
      );
      

    }else{
            this.firstFormGroup.markAllAsTouched();
   
        this.snackBar.open("Form is invalid. Please check all required fields.", '×', { 
          panelClass: 'error', 
          verticalPosition: 'bottom', 
          duration: 3000 
        });
    }
   
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
